
import { formatTextByType } from "./string.js";
import { FormatType } from "./format-type.js";

function processInlineContent(contentNodes, linkedinText, mentions) {
  if (!contentNodes) return linkedinText;
  contentNodes.forEach((content) => {
    if (content.marks) {
      if (!content.text) {
        if (content.type === "hardBreak") {
          linkedinText += "\n";
        }
      } else {
        let shouldBold = false;
        let shouldItalic = false;
        content.marks.forEach((mark) => {
          if (mark.type === "bold") {
            shouldBold = true;
          } else if (mark.type === "italic") {
            shouldItalic = true;
          } else if (mark.type === "textStyle") {
            // do nothing
          }
        });
        if (shouldBold && shouldItalic) {
          let t = formatTextByType(content.text, FormatType.bold);
          linkedinText += formatTextByType(t, FormatType.italic);
        } else if (shouldBold) {
          linkedinText += formatTextByType(content.text, FormatType.bold);
        } else if (shouldItalic) {
          linkedinText += formatTextByType(content.text, FormatType.italic);
        } else {
          if (content.type === "text") {
            linkedinText += content.text;
          } else if (content.type === "hardBreak") {
            linkedinText += "\n";
          }
        }
      }
    } else {
      if (content.type === "mention") {
        linkedinText += content.attrs.label;
        let start = Array.from(linkedinText).length - Array.from(content.attrs.label).length;
        mentions.push({
          "id": content.attrs.id,
          "text": content.attrs.label,
          "type": content.attrs.type || "company",
          "start": start,
          "length": Array.from(content.attrs.label).length,
        });
      } else {
        if (content.type === "text") {
          linkedinText += content.text;
        } else if (content.type === "hardBreak") {
          linkedinText += "\n";
        }
      }
    }
  });
  return linkedinText;
}

function getListPrefixes(listType, nestingLevel, index) {
  const indentation = "  ".repeat(nestingLevel);

  if (listType === "ordered") {
    const marker = `${index}. `;
    return {
      itemPrefix: `${indentation}${marker}`,
      continuationPrefix: `${indentation}${" ".repeat(marker.length)}`,
    };
  }

  return {
    itemPrefix: `${indentation}• `,
    continuationPrefix: `${indentation}  `,
  };
}

function serializeListItem(listItem, linkedinText, mentions, { listType, nestingLevel, index }) {
  if (listItem.type !== "listItem" || !listItem.content) {
    return linkedinText;
  }

  let hasPrefixedParagraph = false;
  const { itemPrefix, continuationPrefix } = getListPrefixes(listType, nestingLevel, index);

  listItem.content.forEach((node) => {
    if (node.type === "paragraph" || node.type === "heading") {
      linkedinText += hasPrefixedParagraph ? continuationPrefix : itemPrefix;
      linkedinText = processInlineContent(node.content, linkedinText, mentions);
      linkedinText += "\n";
      hasPrefixedParagraph = true;
    } else if (node.type === "bulletList" || node.type === "orderedList") {
      linkedinText = serializeBlock(node, linkedinText, mentions, nestingLevel + 1);
    } else {
      linkedinText += "\n";
    }
  });

  return linkedinText;
}

function serializeBlock(block, linkedinText, mentions, nestingLevel = 0) {
  if (block.type === "paragraph" || block.type === "heading") {
    linkedinText = processInlineContent(block.content, linkedinText, mentions);
    linkedinText += "\n";
    return linkedinText;
  }

  if (block.type === "bulletList") {
    if (block.content) {
      block.content.forEach((listItem) => {
        linkedinText = serializeListItem(listItem, linkedinText, mentions, {
          listType: "bullet",
          nestingLevel,
        });
      });
    }
    return linkedinText;
  }

  if (block.type === "orderedList") {
    if (block.content) {
      let index = block.attrs?.start || 1;
      block.content.forEach((listItem) => {
        linkedinText = serializeListItem(listItem, linkedinText, mentions, {
          listType: "ordered",
          nestingLevel,
          index,
        });
        index++;
      });
    }
    return linkedinText;
  }

  linkedinText += "\n";
  return linkedinText;
}

function convertJSONToLinkedInTextAndMentions(tapJson) {
  let linkedinText = "";
  let mentions = [];
  tapJson.content.forEach((block) => {
    linkedinText = serializeBlock(block, linkedinText, mentions);
  });
  return {
    text: linkedinText,
    mentions: mentions,
  };
}

function convertLinkedInTextToJSON(linkedinText) {
  let json = {
    type: "doc",
    content: [
      {
        type: "paragraph",
        content: []
      }
    ]
  };
  let currentParagraph = json.content[0];
  let currentText = "";
  for (let i = 0; i < linkedinText.length; i++) {
    let c = linkedinText[i];

    if (c === "\n") {
      if (currentText.length > 0) {
        currentParagraph.content.push({
          type: "text",
          text: currentText,
        });
      }
      currentText = "";

      currentParagraph = {
        type: "paragraph",
        content: []
      };
      json.content.push(currentParagraph);
    } else {
      currentText += c;
    }
  }

  if (currentText.length > 0) {
    currentParagraph.content.push({
      type: "text",
      text: currentText,
    });
  }
  return json;
}


export {
  convertJSONToLinkedInTextAndMentions,
  convertLinkedInTextToJSON,
};
